module.exports = __webpack_public_path__ + "img/nodata.f5f9b393.png";